<script setup lang="ts">
const app = useNuxtApp()
const isProduct = app.payload['is_product'] === true
</script>

<template>
  <div>
    <!-- Lazy is load-bearing: v-if skips render, not download. -->
    <LazyProductPage v-if="isProduct" />
    <LazyHierarchyPage v-else />
  </div>
</template>
